import React, { useEffect } from 'react';
import { Form, Modal, Radio } from '@maxtropy/components';
import { apiV2EnergyConsumptionPlanAddApplyConfigPost } from '@maxtropy/device-customer-apis-v2';
import { OrgMapProps } from '..';
import { isNil } from 'lodash-es';
interface ConfigModalProps {
  onClose: () => void;
  updateFn: () => void;
  data?: OrgMapProps;
}

const ConfigModal = ({ onClose, updateFn, data }: ConfigModalProps) => {
  const [form] = Form.useForm();

  const onOk = () => {
    const value = form.getFieldsValue();
    apiV2EnergyConsumptionPlanAddApplyConfigPost({ ...value, id: data?.id }).then(() => {
      updateFn();
      onClose();
    });
  };

  useEffect(() => {
    if (data) {
      form.setFieldsValue({ limitTime: isNil(data.limitTime) ? true : data.limitTime });
    }
  }, [data]);

  return (
    <Modal title="计划申请配置" open={true} onCancel={onClose} onOk={onOk} contentClassName="modal-form-content">
      <Form form={form} isOrigin={true}>
        <Form.Item label="是否限制用能计划时间" name="limitTime">
          <Radio.Group
            options={[
              { value: true, label: '是' },
              { value: false, label: '否' },
            ]}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ConfigModal;
